export enum Fondsgruppenart  {
  FONDSGRUPPE = 'FONDSGRUPPE',
  FONDS = 'FONDS'
}
